import React from "react";
import styled from "styled-components";
import {getCssSizeValue} from "@/utils/utils";
import Icon from "@/components/common/Icon/Icon";
import {ICONS} from "@/constants";


const StyledVideoControls = styled.div`
    position: absolute;
    z-index: 5;
	top: 50%;
	left: 50%;
	translate: -50% -50%;
    height: ${getCssSizeValue(100)};
    width: ${getCssSizeValue(100)};
    border-radius: 50%;
    background: ${({theme}) => theme.colors.platinum};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;

    transition: all .2s ease-in-out;

    &.thumbnail {
		translate: 0 0;
		top: unset;
		left: unset;
		bottom: ${getCssSizeValue(18)};
		right: ${getCssSizeValue(16)};
        height: ${getCssSizeValue(50)};
        width: ${getCssSizeValue(50)};
		
        .icon {
            width: ${getCssSizeValue(20)};
            height: ${getCssSizeValue(16)};
        }
    }

	&.hovered {
		bottom: 50%;
		right: 50%;
		translate: 50% 50%;
	}
	
    &:hover {
        transform: scale(1.05);
    }

    .icon {
        width: ${getCssSizeValue(40)};
        height: ${getCssSizeValue(32)};
    }
`

export default function VideoControls({
	handleToggleVideo,
	isVideoPlaying,
	thumbnail = false,
	hovered = false
}) {
	return (
		!isVideoPlaying && (
			<StyledVideoControls
				onClick={handleToggleVideo}
				className={`${thumbnail ? 'thumbnail' : ''} ${hovered ? 'hovered' : ''}`}
			>
				<Icon name={ICONS.PLAY} color='richBlue' />
				{/*{isVideoPlaying ? (*/}
				{/*	<>*/}
				{/*		<span className='first' />*/}
				{/*		<span className='second' />*/}
				{/*	</>*/}
				{/*): (*/}
				{/*	<div className='play' />*/}
				{/*)}*/}
			</StyledVideoControls>
		)
	)
}
